import React from 'react'
import { Spinner } from 'react-bootstrap';

export default function LoadingSpinner(props) {

  let text = 'Cargando';
  
  if (props.visualization) {
    text = text + ' (esto puede tardar unos minutos)...';
  } else {
    text = text + '...';
  }

  return (
    <div className="odisea-loading">
        <Spinner animation="grow"/>
        <br />
        <div className="odisea-loading-text">{ text }</div>
    </div>
  )
}
